import { styled } from "@mui/material/styles";
import { Card } from "@mui/material";

export const CustomCard = styled(Card)(({ theme }) => ({
    backdropFilter: "blur(20px)",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    [theme.breakpoints.down('md')]: {
        borderRadius: "unset",
    },
}))